import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { Observable } from 'rxjs';
import { AppSettings } from '../common/app.settings';
import 'rxjs/add/operator/map';

import { ContentHeaders } from '../common/headers';
import { QuestionGroup } from '../models/question.group.model';
import { ApiResult } from '../models/apiresult.model';

@Injectable()
export class QuestionGroupService {
    constructor(
        private http: Http,
        private contentHeaders: ContentHeaders) {
    }

    getQuestionGroups(): Promise<QuestionGroup[]> {
        // get users from api
        return this.http.get(AppSettings.apiEndPoint + '/QuestionGroup/GetQuestionGroups', { headers: this.contentHeaders.headers })
            .map((response: Response) => {
                return response.json();
            })
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    getQuestionGroup(questionGroupId: string): Promise<QuestionGroup> {
        return this.http.get(
            AppSettings.apiEndPoint + '/QuestionGroup/' + questionGroupId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    updateQuestionGroup(questionGroup: QuestionGroup): Promise<ApiResult> {
        return this.http.put(
            AppSettings.apiEndPoint + '/QuestionGroup/' + questionGroup.id,
                JSON.stringify(questionGroup),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    addQuestionGroup(questionGroup: QuestionGroup): Promise<ApiResult> {
        return this.http.post(
            AppSettings.apiEndPoint + '/QuestionGroup/',
                JSON.stringify(questionGroup),
                { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    deleteQuestionGroup(questionGroupId: string): Promise<ApiResult> {
        return this.http.delete(
            AppSettings.apiEndPoint + '/QuestionGroup/' + questionGroupId,
            { headers: this.contentHeaders.headers }
            )
            .map((response: Response) => response.json())
            .toPromise()
            .catch(this.handleErrorPromise);
    }

    private handleErrorPromise(error: any): Promise<void> {
        try {
            error = JSON.parse(error._body);
        } catch (e) {
        }

        const errMsg = error.errorMessage
            ? error.errorMessage
            : error.message
            ? error.message
            : error._body
            ? error._body
            : error.status
            ? `${error.status} - ${error.statusText}`
            : 'unknown server error';

        console.error(errMsg);
        return Promise.reject(errMsg);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/question.group.service.ts